import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-20 md:py-32 bg-brown-dark text-center relative overflow-hidden" data-id="element-49">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-50">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-gold rounded-full mix-blend-multiply filter blur-3xl" data-id="element-51"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-olive rounded-full mix-blend-multiply filter blur-3xl" data-id="element-52"></div>
        <div className="absolute top-1/2 right-1/3 w-48 h-48 bg-olive rounded-full mix-blend-multiply filter blur-2xl" data-id="element-53"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-55">
          <div className="mb-10 space-y-2" data-id="element-56">
            <p className="text-xl md:text-2xl text-beige/80 font-medium" data-id="element-57">
              Podés seguir dudando… o podés empezar hoy.
            </p>
            <p className="text-xl md:text-2xl text-olive-light font-bold" data-id="element-58">
              Nadie va a venir a hacerlo por vos.
            </p>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold mb-12 leading-tight" data-id="element-59">
            <span className="text-olive-light" data-id="element-60">Tu cocina</span>{' '}
            <span className="text-gold" data-id="element-61">puede ser tu ingreso</span>
          </h2>

          <motion.a href="https://lacocinaquevende.shop/cart/53476221124881:1" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold hover:bg-gold-hover text-brown-dark font-bold text-xl py-5 px-10 rounded-full shadow-[0_0_30px_rgba(201,169,110,0.3)] transition-all duration-300" data-id="element-62">
            👉 COMPRAR AHORA
          </motion.a>
        </motion.div>
      </div>
    </section>;
}